import classNames from 'classnames';
import { isString } from 'lodash';
import { ReactNode } from 'react';

import { cleanExternalLinks } from '../../lib/utils';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/fields/field-label.module.css';

interface FieldLabelProps {
    children?: ReactNode;
    className?: string;
    [key: string]: any;
}

function FieldLabel({ children = null, className = null, ...props }: FieldLabelProps) {
    const themeClassName = useThemeClassName(styles);
    if (isString(children)) {
        return (
            <label
                className={classNames([styles.container, themeClassName, className])}
                {...props}
                dangerouslySetInnerHTML={{ __html: cleanExternalLinks(children) }}
            />
        );
    }
    return (
        <label className={classNames([styles.container, themeClassName, className])} {...props}>
            {children}
        </label>
    );
}

export default FieldLabel;
